import type { PiralPlugin } from 'piral-core'
import { QueryClient } from '@tanstack/react-query'

export const queryClient = new QueryClient()

export interface QueryApi {
  queryClient(): QueryClient
}

export function createWrwksQueryApi(): PiralPlugin<QueryApi> {
  return () => ({
    queryClient: () => queryClient
  })
}
